module.exports = __webpack_public_path__ + "img/102.a344d532.jpg";